import React, { Component } from 'react'
import axios from 'axios'
import Inspector from './Inspector'
import NextButtons from './NextButtons'
import styles from './Reader.css'

class Reader extends Component {
  constructor(props) {
    super(props)

    this.audioContext = null
    this.initialState = {
      selectedWord: null,
      selectedChunk: null,
      dictWords: null
    }
    this.state = Object.assign(
      {
        activities: []
      },
      this.initialState
    )
  }

  componentDidMount() {
    const AudioContext = window.AudioContext || window.webkitAudioContext
    this.audioContext = new AudioContext()
    this.setState(
      Object.assign(
        {
          activities: [
            {
              time: Date.now(),
              action: ['start']
            }
          ]
        },
        this.initialState
      )
    )
  }

  componentDidUpdate(prevProps) {
    if (!this.hasChanges(prevProps, this.props)) {
      return
    }
    this.setState(
      Object.assign(
        {
          activities: [
            {
              time: Date.now(),
              action: ['start']
            }
          ]
        },
        this.initialState
      )
    )
  }

  hasChanges(props1, props2) {
    if (props1.rowKey && props2.rowKey) {
      return props1.rowKey !== props2.rowKey
    }
    return this.hasRowChanges(props1.row, props2.row)
  }

  hasRowChanges(row1, row2) {
    if (row1.length !== row2.length) {
      return true
    }
    return row1.some((elem, index) => elem !== row2[index])
  }

  copyState() {
    const state = Object.assign({}, this.state)
    state.activities = state.activities.map((a) => Object.assign({}, a))
    return state
  }

  recordActivity(action, callback) {
    const state = this.copyState()
    state.activities.push({
      time: Date.now(),
      action: action
    })
    this.setState(state, () => {
      if (this.props.onActivitiesRecorded) {
        this.props.onActivitiesRecorded(this.state.activities)
      }
      if (!callback) {
        return
      }
      callback()
    })
  }

  resolveTranslateRequest(words) {
    if (this.props.translateRequest) {
      return this.props.translateRequest(words)
    }
    return axios.post(`${this.props.baseURL || ''}/translate`, {
      words: words.join(' ')
    })
  }

  resolveWordRequest(word) {
    if (this.props.wordRequest) {
      return this.props.wordRequest(word.toLowerCase())
    }
    return axios.get(`${this.props.baseURL || ''}/word/${word.toLowerCase()}`)
  }

  resolveJaWordRequest(word) {
    if (this.props.jaWordRequest) {
      return this.props.jaWordRequest(word.toLowerCase())
    }
    return axios.get(`${this.props.baseURL || ''}/jaword/${word.toLowerCase()}`)
  }

  wordClick(word, index) {
    if (this.props.disableWordClick) {
      return
    }
    console.log('Word', word)
    const state = this.copyState()
    const wordChunks =
      (this.props.chunks || [])[this.props.rowOffset + index] || []
    state.selectedWord = index
    if (
      !state.selectedChunk ||
      state.selectedChunk.word !== this.props.rowOffset + index ||
      state.selectedChunk.candidate + 1 >= wordChunks.length
    ) {
      state.selectedChunk = {
        word: this.props.rowOffset + index,
        candidate: -1,
        words: [this.props.rowOffset + index]
      }
    } else {
      state.selectedChunk = {
        word: this.props.rowOffset + index,
        candidate: state.selectedChunk.candidate + 1,
        words: wordChunks[state.selectedChunk.candidate + 1]
      }
    }
    state.dictWords = state.selectedChunk.words.map(
      (i) => (this.props.row[i - this.props.rowOffset] || '').split('|')[0]
    )
    console.log('Chunks', wordChunks, state.selectedChunk)
    this.setState(state, () => {
      this.wordsOpen(state.dictWords)
    })
  }

  chunkContains(index) {
    if (!this.state.selectedChunk) {
      return false
    }
    return (this.state.selectedChunk.words || []).includes(
      this.props.rowOffset + index
    )
  }

  closeDict() {
    const state = this.copyState()
    state.dictWords = null
    state.selectedWord = null
    state.selectedChunk = null
    this.setState(state)
  }

  googleSearch(word, callback) {
    this.recordActivity(['googlesearch', word], () => {
      if (!this.props.onGoogleSearch) {
        callback()
        return
      }
      this.props.onGoogleSearch(word, callback)
    })
  }

  enDictRequest(word) {
    this.recordActivity(['englishdictionary', word], () => {
      if (!this.props.onEnDictRequest) {
        return
      }
      this.props.onEnDictRequest(word)
    })
  }

  jaDictRequest(word) {
    this.recordActivity(['japanesedictionary', word], () => {
      if (!this.props.onJaDictRequest) {
        return
      }
      this.props.onJaDictRequest(word)
    })
  }

  jpTranslateRequest(words) {
    this.recordActivity(['translate', words], () => {
      if (!this.props.onJpTranslateRequest) {
        return
      }
      this.props.onJpTranslateRequest(words)
    })
  }

  wordsOpen(words) {
    this.recordActivity(['open', words], () => {
      if (!this.props.onWordsOpen) {
        return
      }
      this.props.onWordsOpen(words)
    })
  }

  nextClicked(e) {
    if (!this.props.onNext) {
      return
    }
    this.props.onNext(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['next']
        }
      ])
    )
  }

  previousClicked(e) {
    if (!this.props.onPrevious) {
      return
    }
    this.props.onPrevious(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['previous']
        }
      ])
    )
  }

  nextPageClicked(e) {
    if (!this.props.onNextPage) {
      return
    }
    this.props.onNextPage(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['nextpage']
        }
      ])
    )
  }

  previousPageClicked(e) {
    if (!this.props.onPreviousPage) {
      return
    }
    this.props.onPreviousPage(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['previouspage']
        }
      ])
    )
  }

  exitClicked(e) {
    if (!this.props.onExit) {
      return
    }
    this.props.onExit(
      this.state.activities.concat([
        {
          time: Date.now(),
          action: ['exit']
        }
      ])
    )
  }

  renderHelp() {
    const message = this.props.questionMessage || '文章を読んでみよう！'
    if (this.props.disableWordClick) {
      return message
    }
    return this.state.dictWords !== null
      ? '複数回単語をタップすると句で検索'
      : `${message}単語をタップすると辞書が開きます`
  }

  render() {
    return (
      <div>
        {this.state.dictWords !== null && (
          <Inspector
            words={this.state.dictWords}
            onClose={() => this.closeDict()}
            onEnDictRequest={(w) => this.enDictRequest(w)}
            onJaDictRequest={(w) => this.jaDictRequest(w)}
            onJpTranslateRequest={(w) => this.jpTranslateRequest(w)}
            onGoogleSearch={(word, callback) =>
              this.googleSearch(word, callback)
            }
            onWordsOpen={(words) => this.wordsOpen(words)}
            onAdditionalLinksRequest={this.props.onAdditionalLinksRequest}
            wordRequest={(word) => this.resolveWordRequest(word)}
            jaWordRequest={(word) => this.resolveJaWordRequest(word)}
            translateRequest={(words) => this.resolveTranslateRequest(words)}
          />
        )}
        <div className={styles.Sentence}>
          <div className={styles.DictHelp}>{this.renderHelp()}</div>
          {this.props.row.map((row, index) => (
            <span key={index}>
              {index > 0 && row.split('|')[0].match(/[a-zA-Z0-9]+/) && (
                <span
                  className={`${styles.WordSpace} ${
                    this.chunkContains(index - 1) && this.chunkContains(index)
                      ? styles.WordSelected
                      : ''
                  }`}
                >
                  {' '}
                </span>
              )}
              <span
                key={index}
                className={
                  this.state.selectedWord === index || this.chunkContains(index)
                    ? `${styles.Word} ${styles.WordSelected}`
                    : styles.Word
                }
                onClick={(ev) => this.wordClick(row.split('|')[0], index)}
              >
                {row.split('|')[0]}
              </span>
            </span>
          ))}
        </div>
        <NextButtons
          hint={this.props.hint}
          onHintPerform={this.props.onHintPerform}
          hasPrevious={this.props.hasPrevious}
          hasNext={this.props.hasNext}
          completed={this.props.completed}
          hasPreviousPage={this.props.hasPreviousPage}
          hasNextPage={this.props.hasNextPage}
          onPreviousPage={(ev) => this.previousPageClicked(ev)}
          onNextPage={(ev) => this.nextPageClicked(ev)}
          onPrevious={(ev) => this.previousClicked(ev)}
          onNext={(ev) => this.nextClicked(ev)}
          onExit={(ev) => this.exitClicked(ev)}
        />
      </div>
    )
  }
}

export default Reader
